export enum ExternalRedirectsQueryKeys {
  GetAll = 'externalRedirects/getAll',
  GetOneById = 'externalRedirects/getById',
  Conflicts = 'externalRedirects/conflicts',
  Create = 'externalRedirects/create',
  Edit = 'externalRedirects/edit',
  Delete = 'externalRedirects/delete',
  BulkActivity = 'externalRedirects/bulkActivity',
  BulkDelete = 'externalRedirects/bulkDelete',
  Breadcrumb = 'externalRedirects/breadcrumb'
}
